(function () {
  function norm(s) {
    return (s || "")
      .toString()
      .trim()
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  // Provincias por zona
  const Z1 = [
    "Madrid",
    "Valencia",
    "Alicante",
    "Granada",
    "Álava",
    "Barcelona",
    "Zaragoza",
    "Sevilla"
  ];

  const Z2 = [
    "Albacete",
    "Ávila",
    "Castellón",
    "Ciudad Real",
    "Guadalajara",
    "Guipúzcoa",
    "Málaga",
    "Murcia",
    "Segovia",
    "Toledo",
    "Vizcaya"
  ];

  const Z3 = [
    "Almería",
    "Asturias",
    "Badajoz",
    "Burgos",
    "Cáceres",
    "Cádiz",
    "Cantabria",
    "Córdoba",
    "Cuenca",
    "Gerona",
    "Huelva",
    "Huesca",
    "Jaén",
    "La Coruña",
    "La Rioja",
    "León",
    "Lérida",
    "Lugo",
    "Navarra",
    "Orense",
    "Palencia",
    "Pontevedra",
    "Salamanca",
    "Soria",
    "Tarragona",
    "Teruel",
    "Valladolid",
    "Zamora"
  ];

  // Precios actualizados
  const PRICES = {
    1: { montaje: "69,00 €", retirada: "149,00 €" },
    2: { montaje: "99,00 €", retirada: "149,00 €" },
    3: { montaje: "129,00 €", retirada: "179,00 €" }
  };

  const map = {};
  Z1.forEach(p => map[norm(p)] = 1);
  Z2.forEach(p => map[norm(p)] = 2);
  Z3.forEach(p => map[norm(p)] = 3);

  const provinces = [].concat(Z1, Z2, Z3).sort((a, b) => a.localeCompare(b, "es"));

  function init(root) {
    const uid = root.getAttribute("data-sd-uid") || "sd";
    const sel = root.querySelector("[data-sd-province]");
    const result = root.querySelector("[data-sd-result]");
    const badge = root.querySelector("[data-sd-badge]");
    const priceMontaje = root.querySelector("[data-sd-montaje]");
    const priceRetirada = root.querySelector("[data-sd-retirada]");

    if (!sel || !result || !badge || !priceMontaje || !priceRetirada) return;

    // Rellenar selector sin duplicados
    if (!sel.getAttribute("data-sd-filled")) {
      provinces.forEach(p => {
        const opt = document.createElement("option");
        opt.value = p;
        opt.textContent = p;
        sel.appendChild(opt);
      });
      sel.setAttribute("data-sd-filled", "1");
    }

    // Recordar selección
    const key = "sd_prov_" + uid;
    const saved = localStorage.getItem(key);
    if (saved && !sel.value) sel.value = saved;

    function render() {
      const prov = sel.value;

      if (!prov) {
        result.style.display = "none";
        localStorage.removeItem(key);
        return;
      }

      localStorage.setItem(key, prov);

      const zone = map[norm(prov)];
      result.style.display = "block";

      if (!zone) {
        badge.textContent = "Zona —";
        priceMontaje.textContent = "Consultar";
        priceRetirada.textContent = "Consultar";
        return;
      }

      badge.textContent = "Zona " + zone;
      priceMontaje.textContent = PRICES[zone].montaje;
      priceRetirada.textContent = PRICES[zone].retirada;
    }

    sel.addEventListener("change", render);
    render();
  }

  function boot() {
    document.querySelectorAll(".sd-zonas[data-sd-uid]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();